import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import Link from "../../../components/Link/Link";
import style from './foodblock.module.scss';
import { useEffect, useState } from 'react';
import { fetchFoodInfo } from '../../../services/api'; // Новая функция

const FoodBlock = () => {
    const { settings } = useAccessibility();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Accessibility-aware colors
    const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
    const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';
    const linkColor = settings.contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchFoodInfo();
                // Данные теперь в response.data[0].attributes
                setData(response.data[0].attributes);
                console.log('Food data:', response.data[0].attributes);
            } catch (err) {
                console.error('Error fetching food data:', err);
                setError('Не удалось загрузить данные. Пожалуйста, попробуйте позже.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // File link component
    const FileLink = ({ file, label }) => {
        if (file?.data?.attributes?.url) {
            return (
                <Link
                    href={`${file.data.attributes.url}`}
                    children={`${label} (${file.data.attributes.ext || 'PDF'})`}
                    color={linkColor}
                    fontFamily='Roboto, sans-serif'
                    fontSize='1rem'
                    fontWeight='500'
                    aria-label={`Скачать документ: ${label}`}
                    target="_blank"
                    rel="noopener noreferrer"
                />
            );
        }
        return null;
    };

    if (loading) {
        return (
            <Block
                background={backgroundColor}
                width="75%"
                height="200px"
                justifyContent="center"
                alignItems="center"
            >
                <p style={{ color: textColor }}>Загрузка данных...</p>
            </Block>
        );
    }

    if (error) {
        return (
            <Block
                background={backgroundColor}
                width="75%"
                height="200px"
                justifyContent="center"
                alignItems="center"
            >
                <p style={{ color: textColor }}>{error}</p>
            </Block>
        );
    }

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background={backgroundColor}
            header='ОРГАНИЗАЦИЯ ПИТАНИЯ И ОХРАНА ЗДОРОВЬЯ'
            headerColor={textColor}
            id='food'
            aria-label="Организация питания и охрана здоровья"
            role="region"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData}>
                        {/* Организация питания */}
                        <section aria-labelledby="food-organization">
                            <h4 id="food-organization" className={style.header} style={{ color: textColor }}>
                                Организация питания
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                {data?.FoodDescription ? (
                                    <p>{data.FoodDescription}</p>
                                ) : (
                                    <p>В учреждении отсутствует объект организации питания, в связи с этим отсутствует информация:</p>
                                )}
                                
                                {data?.MissingInfo && data.MissingInfo.length > 0 ? (
                                    <ul className={style.list}>
                                        {data.MissingInfo.map((item) => (
                                            <li key={item.id}>{item.item}</li>
                                        ))}
                                    </ul>
                                ) : (
                                    <ul className={style.list}>
                                        <li>об условиях питания (за исключением обеспечения питанием спортсменов в период проведения спортивных мероприятий)</li>
                                        <li>об условиях питания обучающихся по образовательным программам начального общего образования в государственных и муниципальных общеобразовательных организациях, в том числе:</li>
                                        <li>меню ежедневного горячего питания;</li>
                                        <li>информацию о наличии диетического меню в общеобразовательной организации;</li>
                                        <li>перечни юридических лиц и индивидуальных предпринимателей, оказывающих услуги по организации питания в общеобразовательной организации</li>
                                        <li>перечни юридических лиц и индивидуальных предпринимателей, поставляющих (реализующих) пищевые продукты и продовольственное сырье в общеобразовательную организацию;</li>
                                        <li>форму обратной связи для родителей обучающихся и ответы на вопросы родителей по питанию.</li>
                                    </ul>
                                )}
                            </div>
                        </section>

                        {/* Охрана здоровья */}
                        <section aria-labelledby="health-protection">
                            <h4 id="health-protection" className={style.header} style={{ color: textColor }}>
                                Охрана здоровья обучающихся
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                {data?.HealthDescription ? (
                                    <p>{data.HealthDescription}</p>
                                ) : (
                                    <p>Условия охраны здоровья обучающихся осуществляются в соответствии с действующим законодательством.</p>
                                )}
                                
                                <h5 className={style.subheader} style={{ color: textColor }}>
                                    Учебно-тренировочные занятия проводятся в соответствии с утвержденным расписанием (для каждой учебно-тренировочной группы), составленным в астрономических часах, с понедельника по субботу:
                                </h5>
                                
                                {data?.TrainingSchedules && data.TrainingSchedules.length > 0 ? (
                                    <ul className={style.list}>
                                        {data.TrainingSchedules.map((schedule) => (
                                            <li key={schedule.id}>{schedule.schedule} для обучающихся в возрасте {schedule.ageGroup}</li>
                                        ))}
                                    </ul>
                                ) : (
                                    <ul className={style.list}>
                                        <li>с 8:00 до 20:00 для обучающихся в возрасте 7-10 лет</li>
                                        <li>с 8:00 до 21:00 для обучающихся в возрасте 10 лет и старше</li>
                                    </ul>
                                )}

                                <h5 className={style.subheader} style={{ color: textColor }}>Медицинские требования:</h5>
                                <p>Все обучающиеся имеют медицинский допуск, оформленный в соответствии с требованиями установленными приказом Министерства здравоохранения Российской Федерации от 23 октября 2020 г. № 1144н.</p>
                                
                                <FileLink 
                                    file={data?.HealthCareFile}
                                    label="Положение об охране здоровья обучающихся"
                                />
                            </div>
                        </section>
                    </div>
                </div>
            </FadeIn>
        </Block>
    );
}

export default FoodBlock;